import { CommonModule } from '@angular/common';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { log } from 'console';

@Component({
  selector: 'app-activity-filter',
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule, MatSelectModule, CommonModule, MatDialogModule],
  templateUrl: './activity-filter.component.html',
  styleUrl: './activity-filter.component.scss'
})
export class ActivityFilterComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ActivityFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  roleTypes: any[] = []

  userName = new FormControl('');
  email = new FormControl('');
  roleType = new FormControl('');
  roleList: any[] = []

  ngOnInit(): void {
    this.roleTypes = this.data.roles
    this.userName.setValue(this.data?.selectedUserName)
    this.email.setValue(this.data?.selectedEmail)
    this.roleType.setValue(this.data?.selectedRoles)

  }

  onClearClick() {
    this.userName.reset()
    this.email.reset()
    this.roleType.reset()
  }

  getRoleList(item: any) {
    this.roleList = item.value
    this.roleType.setValue(item.value)
  }

  onSearchClick() {

    console.log(this.data.district, 'district');
    console.log(this.data.state, 'state');
    console.log(this.roleList, 'roles');
    

    this.dialogRef.close({
      country: this.data?.country,
      userName: this.userName.value,
      email: this.email.value,
      roleTypes: this.roleList,
      state: this.data.state,
      district: this.data.district
    })
  }
}
